import { Icon } from "@legal-500/legal500-design-system";
import type { HierarchicalItem } from "../../types/uiTypes";
import styles from "./forms/Form.module.css";

type ChildrenListProps<T extends HierarchicalItem> = {
  item: T;
  onNavigate: (childId: string) => void;
};

export function ChildrenList<T extends HierarchicalItem>({
  item,
  onNavigate,
}: ChildrenListProps<T>) {
  if (!item.children || item.children.length === 0) {
    return null;
  }

  return (
    <div className={styles.childrenSection}>
      <h3 className={styles.childrenTitle}>Children ({item.children.length})</h3>
      <ul className={styles.childrenList}>
        {item.children.map(child => (
          <li key={child.id} className={styles.childItem}>
            <button
              type="button"
              className={styles.childButton}
              onClick={() => onNavigate(child.id)}
            >
              <Icon icon="folder" size="small" />
              <span className={styles.childName}>{child.name}</span>
              {child.code && <span className={styles.childCode}>({child.code})</span>}
              <Icon icon="chevron-right" size="small" className={styles.childArrow} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
